import classes from './MealsSummary.module.css';

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>an online library to get your fav books</h2>
      <p>
       over 12,000 books and magazine to buy , fast delivery 
      </p>
      <p>
     conatining comics and magaiznes, skate magazines , course bookd , and a lot to avheive
      </p>
    </section>
  );
};

export default MealsSummary;